"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "button.delete": "Supprimer",
  "button.download": "Télécharger",
  "button.close": "Fermer",
  "button.submit": "Soumettre",
  "button.help": "Aide",
  "button.rotate": "Pivoter",
  "button.bookmarks": "Favoris",
  "button.print": "Imprimer",
  "preview.notAvailable": "L'aperçu n'est pas disponible pour ce type de fichier.",
  "preview.passwordRequired": "Mot de passe requis",
  "preview.passwordDesc": "Entrez un mot de passe pour accéder à ce document.",
  "preview.nextDocument": "Document suivant",
  "preview.previousDocument": "Document précédent",
  "loading": "Chargement"
};
exports.default = _default;
